'use client';

import Link from 'next/link';

export default function CTASection() {
  return (
    <section className="py-24 bg-gradient-to-br from-[#111827] to-[#1F2937] text-center relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[conic-gradient(from_0deg,rgba(239,68,68,0.12),rgba(139,92,246,0.08),rgba(59,130,246,0.08),rgba(239,68,68,0.12))] rounded-full blur-[80px] pointer-events-none" />

      <div className="max-w-[1200px] mx-auto px-8 relative">
        <h2 className="text-[36px] md:text-[42px] font-bold tracking-[-1.5px] mb-4 text-white">
          Your next conversation has moments waiting to be found.
        </h2>
        <p className="text-[17px] text-white/60 mb-9 max-w-[480px] mx-auto">
          Get your free booking page in 30 seconds. No credit card, no setup — just start talking.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            href="/start"
            className="inline-flex items-center justify-center gap-2 bg-[#EF4444] text-white px-8 py-4 rounded-full text-[16px] font-semibold shadow-[0_4px_14px_rgba(239,68,68,0.3)] hover:bg-[#DC2626] hover:-translate-y-0.5 transition-all"
          >
            Get Your Free Booking Page &rarr;
          </Link>
          <Link
            href="/home/guides"
            className="inline-flex items-center justify-center px-8 py-4 border border-white/25 text-white rounded-full text-[16px] font-semibold hover:border-white hover:bg-white/[0.04] transition-all"
          >
            Browse Guides
          </Link>
        </div>
        <div className="mt-8 flex gap-6 justify-center text-[13px] text-white/40">
          <span>SOC 2 Certified</span>
          <span>&middot;</span>
          <span>Enterprise-ready</span>
          <span>&middot;</span>
          <span>GDPR-compliant</span>
        </div>
      </div>
    </section>
  );
}
